// Status dos fluxos de adiantamento e reembolso (campo approve de reimbursement_solicitations)

// Adiantamentos (is_advance = 1)
export const ADVANCE_STATUS = {
  WAITING_APPROVAL: 0,
  FINISHED: 1,
  REJECTED: 2,
  WAITING_RECEIPT: 3,
  WAITING_ACCOUNTABILITY: 4,
  WAITING_DEPOSIT: 6,
  ACCOUNTABILITY_REVIEW: 7,
  WAITING_RETURN_VALIDATION: 8,
};

export const ADVANCE_STATUS_LABELS = {
  0: { text: "Aguardando Aprovação", badge: "badge-primary" },
  1: { text: "Finalizado", badge: "badge-success" },
  2: { text: "Rejeitado", badge: "badge-danger" },
  3: { text: "Aguardando Comprovante de Acerto", badge: "badge-warning" },
  4: { text: "Aguardando Prestação de Contas", badge: "badge-danger" },
  5: { text: "Aprovado Parcialmente", badge: "badge-info" },
  6: { text: "Aguardando Depósito", badge: "badge-warning" },
  7: { text: "Prestação de Contas em Análise", badge: "badge-info" },
  8: { text: "Aguardando Validação da Devolução", badge: "badge-warning" },
};

// Resultado da análise da prestação de contas (accountability_result)
export const ADVANCE_RESULT_LABELS = {
  1: { text: "Aprovado Total", badge: "badge-success" },
  2: { text: "Aprovado Parcial", badge: "badge-info" },
  3: { text: "Rejeitado Total", badge: "badge-danger" },
};

export function advanceStatus(value) {
  return ADVANCE_STATUS_LABELS[Number(value)] || { text: "Indefinido", badge: "badge-secondary" };
}

export function advanceResult(value) {
  if (value === null || value === undefined || value === "") return null;
  return ADVANCE_RESULT_LABELS[Number(value)] || null;
}

// Status do reembolso comum (campo approve com is_advance = 0)
export const REIMBURSEMENT_STATUS_LABELS = {
  0: { text: "Aguardando Aprovação", badge: "badge-primary" },
  1: { text: "Finalizado", badge: "badge-success" },
  2: { text: "Rejeitado", badge: "badge-danger" },
  3: { text: "Aguardando Comprovante", badge: "badge-warning" },
};

export function reimbursementStatus(value) {
  return REIMBURSEMENT_STATUS_LABELS[Number(value)] || { text: "Indefinido", badge: "badge-secondary" };
}

// Status + resultado em um único badge (ex.: "Finalizado - Aprovado Parcial").
// Depois de finalizado, a cor segue o resultado da análise.
function combineBadge(status, approve, accountabilityResult) {
  const result = advanceResult(accountabilityResult);
  // "Rejeitado - Rejeitado Total" seria redundante
  if (!result || Number(approve) === ADVANCE_STATUS.REJECTED) return status;
  return {
    text: `${status.text} - ${result.text}`,
    badge: Number(approve) === ADVANCE_STATUS.FINISHED ? result.badge : status.badge,
  };
}

export function advanceStatusBadge(approve, accountabilityResult) {
  return combineBadge(advanceStatus(approve), approve, accountabilityResult);
}

export function reimbursementStatusBadge(approve, accountabilityResult) {
  return combineBadge(reimbursementStatus(approve), approve, accountabilityResult);
}

// Contestação da rejeição de uma despesa pelo colaborador (contest_status de reimbursements)
export const CONTEST_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  DENIED: 3,
};

export const CONTEST_STATUS_LABELS = {
  1: { text: "CONTESTADO", badge: "badge-warning" },
  2: { text: "Contestação aceita", badge: "badge-success" },
  3: { text: "Contestação negada", badge: "badge-danger" },
};

export function contestStatus(value) {
  if (value === null || value === undefined || value === "") return null;
  return CONTEST_STATUS_LABELS[Number(value)] || null;
}
